export default "__VITE_ASSET__PiueL_kY__"